const actionTypes = {
    SET_INITIAL_VALUES: "SET_INITIAL_VALUES",
    SET_PRISTINE_VALUES: "SET_PRISTINE_VALUES",
    SET_FORM_VALUES: "SET_FORM_VALUES",
    SET_FIELD_VALUE: "SET_FIELD_VALUE",
    SET_EDITOR_CONFIG: "SET_EDITOR_CONFIG"
};

export const setFormValues = (editor, values, newFormId = false) => {
    return {type: actionTypes.SET_FORM_VALUES, editor, payload: values, newFormId}
};
export const setPristineValues = (editor, values) => {
    return {type: actionTypes.SET_PRISTINE_VALUES, editor, payload: values}
};
export const setInitialValues = (editor, values) => {
    return {type: actionTypes.SET_INITIAL_VALUES, editor, payload: values}
};
export const setFieldValue = (editor, field, value) => {
    return {type: actionTypes.SET_FIELD_VALUE, editor, field, value}
};
export const setEditorConfig = (editor, componentConfig) => {
    return {type: actionTypes.SET_EDITOR_CONFIG, editor, componentConfig};
}

export default actionTypes;